import React from "react";
import i18n from "i18next";

// Fluent UI Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";

import { baseUrl } from "../../helpers/constants";
import { IUserProduct } from "../../Models/IUserProduct";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";

interface IDeleteUserProductDialogProps {
  userProduct: IUserProduct | undefined;
  isDialogOpen: boolean;
  onDismiss: any;
}

function DeleteUserProductDialog(props: IDeleteUserProductDialogProps) {
  const deleteUserProduct = () => {
    if (props.userProduct) {
      fetchWrapper
        .postWithAuth(`${baseUrl}/api/UserProduct/Delete`, props.userProduct)
        .then((result: any) => {
          props.onDismiss();
        })
        .catch((error) => {});
    }
  };

  return (
    <Dialog
      open={props.isDialogOpen}
      onOpenChange={(ev, data) => {
        if (!data.open) {
          props.onDismiss();
        }
      }}
    >
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{i18n.t<string>("deleteUserProduct")}</DialogTitle>
          <DialogContent>
            {i18n.t<string>("deleteUserProductText")}
          </DialogContent>
        </DialogBody>
        <DialogActions>
          <Button appearance="secondary" onClick={() => props.onDismiss()}>
            {i18n.t<string>("cancel")}
          </Button>

          <Button
            appearance="primary"
            onClick={() => {
              deleteUserProduct();
            }}
          >
            {i18n.t<string>("remove")}
          </Button>
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
}

export default DeleteUserProductDialog;
